<template>
  <div id="content-wrapper">
    <div class="row align-items-center">
      <div class="col-6">Import dữ liệu</div>
      <div class="col-6">
        <base-button
          class="float-right"
          @click="openImport"
          button="Import"
        />
      </div>
    </div>
    <ModalUploadImportFile
      ref="modalImport"
      :dataType="'Multi'"
      :title="'dữ liệu hệ thống'"
    />
  </div>
</template>
<script>
import ModalUploadImportFile from "@/components/modal/ModalUploadImportFile";
export default {
  name: "ImportDuLieu",
  components: {
    ModalUploadImportFile,
  },
  methods: {
    openImport() {
      this.$refs["modalImport"].showModal();
    },
  },
};
</script>